export default __webpack_public_path__ + "static/media/error.1d929f68.svg";